import { Card } from '@coingate/ui/dist/components/Card';
import { Heading } from '@coingate/ui/dist/components/Typography';

import type { SignUpSteps } from '../../constants';
import StepNavigation from './StepNavigation';

type StepContentProps = {
  title: string;
  currentStep: SignUpSteps;
  stepComponent: Record<SignUpSteps, () => React.ReactNode>;
  stepHistory: SignUpSteps[];
  onBack: () => void;
}

const StepContent = ({
  title,
  currentStep,
  stepComponent,
  stepHistory,
  onBack,
}: StepContentProps) => {
  return (
    <div className="flex flex-col gap-6 text-center">
      <div className="flex flex-col gap-4">
        <img src="/coingate-logo.svg" alt="CoinGate" className="mx-auto" />

        <Heading.H1 className="text-white text-2xl! mb-0!">
          {title}
        </Heading.H1>
      </div>

      <Card appearance="solid" rounded="2xl" borderless className="mx-6 p-6 sm:p-9">
        {stepComponent[currentStep]()}
      </Card>

      <StepNavigation
        isFirstStep={stepHistory.length === 1}
        onBack={onBack}
      />

      <div className="left-0 right-0 flex flex-col items-center gap-4 lg:hidden mt-8">
        <div className="text-xs font-normal text-white">
          Trusted by 500+ companies
        </div>

        <img src="/companies-mobile.svg" />
      </div>
    </div>
  );
}

export default StepContent
